




































































































































































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { RolesModule } from '@/store/Settings/RolesModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import RoleEdit from '@/components/Settings/Roles/RoleEdit.vue';
import PageNames from '@/router/PageNames';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'RoleDetails', components: { RoleEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get role() {
        return RolesModule.role;
    }

    get institutionConfig() {
        return AuthModule.me.institution.config;
    }

    get institutionLabels() {
        return AuthModule.me.institution.config.labels;
    }

    async deleteRole() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this role?', options);
        if (result) {
            await RolesModule.deleteRole();
            this.$router.push({ name: PageNames.Roles });
        }
    }

}
